import { render, staticRenderFns } from "./BulkRestock.vue?vue&type=template&id=a916d55a"
import script from "./BulkRestock.vue?vue&type=script&lang=js"
export * from "./BulkRestock.vue?vue&type=script&lang=js"
import style0 from "./BulkRestock.vue?vue&type=style&index=0&id=a916d55a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports